module.exports = __webpack_public_path__ + "static/scale-model-of-alexander-brest-museum-in-jacksonville-florida-b443b983da67151354c606fcb4b1bf93.png";